import { currentAuthUser } from "./api";
import { getActiveBusinessId } from "./business";

// True, wenn die aktive Organisation im (laufenden) Probezeitraum ist.
// System-Admins sind nie eingeschränkt.
export function isActiveBusinessTrial(): boolean {
  const user = currentAuthUser();
  if (!user || user.role === "system_admin") return false;
  const activeId = getActiveBusinessId();
  const biz =
    user.businesses?.find((b) => String(b.business_id) === String(activeId)) ??
    user.businesses?.[0];
  return !!biz?.business_trial_active;
}

// Ansichts-Link der Testphase (Seitenbilder statt Datei, siehe Backend
// DocumentPreviewsController). Dafür gibt es keinen Download.
export function isPreviewUrl(url?: string | null): boolean {
  return !!url && url.includes("/api/v1/previews/");
}
